import { PricingFile, WarrantyType } from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { privateAxios } from "../axios";
import { pricingFilesQueryKeys } from "../query-keys/pricing-files.query-keys";

export const getPricingFileUrlById = async (id: number) => {
	try {
		const { data } = await privateAxios.get<{
			url: string;
			pricingFile: PricingFile;
		}>(`/pricing-files/url/${id}`);
		return data;
	} catch (error) {
		if (error instanceof AxiosError && error.response?.status === 404) {
			return null;
		}
		throw error;
	}
};

export const useGetPricingFileUrlById = (id: number) => {
	return useQuery({
		queryKey: pricingFilesQueryKeys.urlById(id),
		queryFn: () => getPricingFileUrlById(id),
		enabled: !!id,
		retry: false,
		throwOnError: false,
	});
};

export const getPricingFileUrlByWarrantyTypeAndBinderAmendmentId = async (
	warrantyType: WarrantyType,
	binderAmendmentId: number,
) => {
	try {
		const { data } = await privateAxios.get<{
			url: string;
			pricingFile: PricingFile;
		}>("/pricing-files/url", {
			params: {
				warrantyType,
				binderAmendmentId,
			},
		});
		return data;
	} catch (error) {
		if (error instanceof AxiosError && error.response?.status === 404) {
			return null;
		}
		throw error;
	}
};

export const useGetPricingFileUrlByWarrantyTypeAndBinderAmendmentId = (
	warrantyType: WarrantyType,
	binderAmendmentId: number,
) => {
	return useQuery({
		queryKey: pricingFilesQueryKeys.urlByWarrantyTypeAndBinderAmendmentId(
			warrantyType,
			binderAmendmentId,
		),
		queryFn: () =>
			getPricingFileUrlByWarrantyTypeAndBinderAmendmentId(
				warrantyType,
				binderAmendmentId,
			),
		enabled: !!warrantyType && !!binderAmendmentId,
		retry: false,
		throwOnError: false,
	});
};
